// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__qCNng","black":"siteholder_black__6QGSN","white":"siteholder_white__2Wqf2","img":"siteholder_img__3jlvH","zoomin":"siteholder_zoomin__1t9D5"};